import React, { createContext, useContext } from 'react';

const SiteContext = createContext({
  event:                   null,
  forms:                   [],
  organization:            null,
  lobby:                   null,
  navMode:                 'event',
  prefetchRef:             null,
  startTransitionRef:      null,
  startLobbyTransitionRef: null,
  pageReadyRef:            null,
  afterTransitionRef:      null,
  isTransitioning:         false,
  // Event page header — set by EventPage so the shell can render it
  setEventHeader:          null, // ({ headerSection, headerConfig, bp }) => void
  // Raw event.layout.header — used by FormPage/LoginPage to compute top padding
  shellHeaderConfig:       {},
  // Raw event.layout.footer — used by FormPage/LoginPage to render the builder footer
  shellFooterConfig:       {},
});

export const SiteProvider = ({ value, children }) => (
  <SiteContext.Provider value={value}>
    {children}
  </SiteContext.Provider>
);

export const useSite = () => useContext(SiteContext);

export default SiteContext;